import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcHelp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0m1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11.25 13c0-.978.779-1.64 1.389-1.929.343-.162.67-.41.884-.69.212-.275.278-.527.239-.75-.128-.723-.826-1.227-1.684-1.133-.717.08-1.176.482-1.35 1.182a.75.75 0 0 1-1.457-.36c.325-1.311 1.3-2.165 2.643-2.313 1.512-.166 3.037.737 3.324 2.362.134.754-.138 1.422-.524 1.925-.383.5-.913.886-1.433 1.133-.388.184-.531.447-.531.573a.75.75 0 0 1-1.5 0"
  }));
}
var IcHelp = createNolIcon(/*#__PURE__*/forwardRef(SvgIcHelp));

export { IcHelp as I };
